// extracted by mini-css-extract-plugin
module.exports = {"animated":"e_Hd","dots":"e_Id"};